(() => {
  const init = (root) => {
    if (!root || root.dataset.lammaReady === 'true') return;
    root.dataset.lammaReady = 'true';

    const form = root.querySelector('.lamma-product-form');
    if (!form) return;

    const qty = form.querySelector('[data-lamma-qty]');
    const variantSelect = form.querySelector('[data-lamma-variant-select]');
    const variantInput = form.querySelector('[data-lamma-variant-input]');
    const price = root.querySelector('[data-lamma-price]');
    const stickyPrice = root.querySelector('[data-lamma-sticky-price]');
    const buyNow = form.querySelector('[data-lamma-buy-now]');
    const stickyTrigger = root.querySelector('[data-lamma-sticky-trigger]');

    const currentVariantId = () => variantSelect?.value || variantInput?.value;
    const currentQty = () => Math.max(1, parseInt(qty?.value || '1', 10) || 1);

    form.querySelector('[data-lamma-qty-minus]')?.addEventListener('click', () => {
      qty.value = Math.max(1, currentQty() - 1);
    });
    form.querySelector('[data-lamma-qty-plus]')?.addEventListener('click', () => {
      qty.value = currentQty() + 1;
    });

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (option?.dataset.price) {
        price.textContent = option.dataset.price;
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      }
    });

    const goToCheckout = () => {
      const variantId = currentVariantId();
      if (!variantId) return;
      const rootPath = window.Shopify?.routes?.root || '/';
      window.location.href = `${rootPath}cart/${variantId}:${currentQty()}`;
    };

    buyNow?.addEventListener('click', goToCheckout);
    stickyTrigger?.addEventListener('click', goToCheckout);

    root.querySelectorAll('[data-lamma-media-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.lammaMediaTarget;
        root.querySelectorAll('.lamma-gallery__slide').forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === id));
        root.querySelectorAll('.lamma-gallery__thumb').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  };

  const initAll = () => document.querySelectorAll('[data-lamma-product-section]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
